<template>
  <q-tabs
    class="transfer-type-tabs"
    :model-value="modelValue"
    active-color="primary"
    indicator-color="primary"
    content-class="justify-start"
  >
    <q-tab
      v-for="item in transferTypes"
      :key="item"
      v-intersection.once="{
        handler: (e) => onIntersection(item, e),
        cfg: {
          threshold: 1.0,
        },
      }"
      :name="item"
      :class="item"
      @click="$emit('update:modelValue', item)"
    >
      <div class="flex no-wrap items-center">
        <q-icon
          :name="item"
          size="24px"
        />
        <div class="fs-12 q-ml-8 q-tab__label">
          {{ $t(`transfer.type.${item}`) }}
        </div>
      </div>
    </q-tab>
  </q-tabs>
</template>

<script setup>
import { computed, inject } from 'vue';

defineProps({
  modelValue: {
    type: String,
    required: true,
  },
});

const emit = defineEmits(['tab-visible', 'update:modelValue']);

const isCapacitor = inject('isCapacitor');

const transferTypes = computed(() => {
  const types = ['route', 'hourly', 'delivery'];

  if (isCapacitor) {
    types.push('car_rental', 'experience');
  }

  return types;
});

function onIntersection(tabName, { isIntersecting }) {
  if (isIntersecting) {
    emit('tab-visible', tabName);
  }
}
</script>

<style lang="scss" scoped>
.transfer-type-tabs {
  margin: 0 -16px;

  .q-tab {
    flex-grow: 1;
    padding: 0 12px;

    &.car_rental .q-icon {
      width: 36px;
    }
  }
}
</style>
